import { useState, useEffect } from 'react';
import api from '../services/api';

export function usePlan() {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/admin/me/plan')
      .then((res) => setPlan(res.data))
      .catch(() => setPlan(null))
      .finally(() => setLoading(false));
  }, []);

  const canCreateSurvey = plan
    ? plan.remaining_surveys === null || plan.remaining_surveys > 0
    : true;
  const isFreePlan = plan?.plan?.slug === 'free';

  return {
    plan,
    loading,
    canCreateSurvey,
    isFreePlan,
    remainingSurveys: plan?.remaining_surveys ?? null,
    surveyCount: plan?.survey_count ?? 0,
  };
}
